import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "@app/shared/auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styles: [],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
    autoplay: true,
  };

  passShow: boolean = false;
  constructor(
    private router: Router,
    private authService: AuthService,
    public toasterService: ToastrService
  ) {}

  ngOnInit() {
    this.loginForm = new FormGroup({
      userName: new FormControl("", [
        Validators.required,
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      password: new FormControl("", [
        Validators.required,
        // Validators.pattern('(?=.[a-z])(?=.[A-Z])(?=.\\d)(?=.[@$!%?&])[A-Za-z\\d@$!%?&]{6,40}')
      ]),
    });
  }
  passwordShow() {
    this.passShow = !this.passShow;
}
  login() {
    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.getRawValue()).subscribe(
        (res) => {
          console.log(res);
          if (res.token) {
            console.log("Login Validation Staart");
            localStorage.setItem("bearer", res.token);
            this.authService.fetchUserInfo().subscribe((res) => {
              console.log("userInfo", res);

              localStorage.setItem("user", JSON.stringify(res));
              if (res) {
                let url =
                  res && (res?.userType == "client" || res?.userType == "subuser")
                    ? "customer/dashboard"
                    : "dashboard";
                this.router.navigateByUrl("app/pages/" + url);
              }
            });
            console.log("Login Validation end");
            //this.router.navigateByUrl("");
          } else if (res.errors) {
            this.toasterService.error(
              res?.errors[0]?.message
                ? res?.errors[0]?.message
                : "Some error occured",
              "Error",
              {
                positionClass: "toast-top-right",
              }
            );
          }
        },
        (err) => {
          console.log(err);
          this.toasterService.error(
            err?.errors[0]?.message
              ? err?.errors[0]?.message
              : "Some error occured",
            "Error",
            {
              positionClass: "toast-top-right",
            }
          );
        }
      );
    }
  }
}
